import { useMutation } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';
import type { LintRequest } from '../types/terminology';

/**
 * POST /api/eraf/terminology/lint-reports
 * mutation — { text } → LintReportResponse (transient 계산 결과, 서버 미영속)
 */
export function useLintText() {
  return useMutation({
    mutationFn: (body: LintRequest) => terminologyApi.lintText(body),
  });
}
